export const ERROR = 'error';
export const WARNING = 'warning';
export const OK = 'success';